/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Empty, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Officers from './officers'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_term_uid, barangay_uid } = AuthStore
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Utilities</a></li>
									<li className="breadcrumb-item active">Barangay Officials and Staffs</li>
								</ol>
							</div>
							<h4 className="page-title">Barangay Officials and Staffs</h4>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								{
									!barangay_term_uid &&
									<Row>
										<div className="alert alert-danger alert-dismissible fade show" role="alert">
											{/* <button type="button" className="close" data-dismiss="alert" aria-label="Close">
												<span aria-hidden="true">×</span>
											</button> */}
											<strong>Warning!</strong> Barangay Term not defined in the system, 
											please check your setup in Utilities > Data Lookup Management module.
										</div>
									</Row>
								}
								<Query 
									query={BARANGAY_POSITIONS} 
									variables={{ searchFilter: {
										page: 1, pageSize: 1000, searchText: ''
									}, barangay_uid }}
									fetchPolicy='network-only'
								>
									{({ loading, error, data }) => {
										if (error) return <Empty/>

										let barangayPositions = _.has(data,'barangayPositions') ? data.barangayPositions.data : []
										return (
											<Row type='flex' justify='center'>
												<Col md={22} sm={24}>
													{
														barangayPositions.map((barangayPosition, key) => {

															return (
																<Row key={key} style={{ marginTop: '30px' }}>
																	<Col md={24} sm={24}>
																		<h4 style={{ color: '#605F5F' }}>{barangayPosition.name}</h4>
																	</Col>
																	<Col md={24} sm={24}>
																		<Officers barangayPosition={barangayPosition} />
																	</Col>
																</Row>
															)
														})
													}
												</Col>
											</Row>
										)
									}}
								</Query>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const BARANGAY_POSITIONS = gql`
    query barangayPositions($barangay_uid: String, $searchFilter: SearchParams) {
		barangayPositions(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
